import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ButtonDesign from "../../components/ButtonDesign/ButtonDesign";

import "./Team.css";

const Team = ({ innerRef }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleNavigation = (page) => {
		navigate("/" + page);
	};

	return (
		<div id="home-team" ref={innerRef} className="team-bg">
			<h2 className="team-title">{t("team.featured.title")}</h2>

			<div className="team-description-container">
				<div className="team-description-image">
					<img
						alt="Luis Ramírez y Silvana Aguilera, equipo de desarrollo digital, diseño UX/UI y marketing digital personalizado."
						src={require("../../assets/" + t("team.featured.image"))}
						className="team-description-image-img"
					/>
				</div>
				<div className="team-description-right">
					<h4>{t("team.featured.description")}</h4>
					<div className="team-description-button">
						<ButtonDesign
							data={{
								text: t("team.featured.button"),
								icon: true,
								dynamic: false,
							}}
							handleClick={() => handleNavigation("equipo")}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Team;
